const productVariantsSection = document?.querySelector(
  '.product-variants .variants-wrapper',
);

const variantButtons =
  productVariantsSection?.querySelectorAll('a:not(.active)');
variantButtons?.forEach((button) => {
  button?.addEventListener('mouseover', function (e) {
    const variantImage = e?.target?.dataset?.image;
    const imageUrl = `${variantImage}`;

    const activeSlide = document?.querySelector(
      '.product__media-list .product__media-item.is-active',
    );
    if (activeSlide) {
      const productMedia = activeSlide?.querySelector('.product__media');

      if (productMedia && imageUrl) {
        productMedia.style.backgroundImage = `url("${imageUrl}")`;
        activeSlide.classList.add('show-variant');
      }
    }
  });
  button?.addEventListener('mouseout', function (e) {
    const activeSlide = document?.querySelector(
      '.product__media-list .product__media-item.is-active',
    );

    if (activeSlide) {
      const productMedia = activeSlide?.querySelector('.product__media');
      if (productMedia) {
        productMedia.style.backgroundImage = 'none';
      }

      activeSlide.classList.remove('show-variant');
    }
  });
});
